import React, { useState } from 'react';
import {
    BetaModalOverlay,
    ModalContainer,
    ModalCloseButton,
    InfoRow,
    TextWrapper,
    TopLine,
    Heading,
    Subtitle,
    ImgWrap,
    Img,
    FormButton,
    BtnWrap
} from './BetaModalElements';

import img1 from '../../images/img1.jpg';
import img2 from '../../images/img2.jpg'
import img3 from '../../images/img3.jpg'
import img4 from '../../images/img4.jpg'

const BetaModal = ({ isOpen, onClose }) => {
    const [page, setPage] = useState(1);

    if (!isOpen) return null;

    const handleClick = (e) => {
        e.preventDefault();
        if (page < 4) {
            setPage(page + 1);
        }
        else {
            setPage(1);
            onClose(e);
        }
    };

    const handleBack = (e) => {
        e.preventDefault();
        if (page > 1) {
            setPage(page - 1);
        }
        else {
            setPage(1);
        }
    };

    // Page content data
    const pageContent = [
        {
            topLine: "Welcome to Lay Trader",
            img: img1,
            heading: "Participation In The Closed Beta",
            subtitle: "Should you choose to participate in our closed beta please note that Lay Trader is still in active development. This closed beta gives you access to Lay Trader pre-launch and gives us an opportunity to test and validate system functionality. This beta is focused on testing new client sign up, account integration, and platform scalability. That said, functionality of the Lay Trader system and performance of the AI Trading Services is not guaranteed. This beta is subject to the following restrictions and assumptions as detailed on the following pages."
        },
        {
            topLine: "Nuanced Operations",
            img: img2,
            heading: "During Closed Beta Period",
            subtitle: "Usage will be restricted to Schwab brokerage accounts and users are required to authenticate their Lay Trader tools weekly. Authorizing your account allows you to leverage the Lay Trader tools available during the beta period. During the beta period all trades will execute in the morning hours after market open, this is NOT currently configurable. Lay Trader will execute trades for you daily so please be cognizant of your account restrictions and any relevant tax implications."
        },
        {
            topLine: "Beta Restrictions",
            img: img3,
            heading: "Limited Set of Stocks and Trading Controls",
            subtitle: "The beta period is testing specific trading tools, by agreeing to participate you are agreeing to use those tools. When you authorize your account and create a job you are choosing which stocks and trades for Lay Trader to execute based on your watchlist selection."
        },
        {
            topLine: "Feedback and further terms",
            img: img4,
            heading: "We appreciate your participation",
            subtitle: "We thank you for choosing to participate in the beta. We're excited to have you as part of our community. At the conclusion of the beta period you will be asked to provide feedback as a user to help improve our platform for the general public. Please reach out to contact@laytrader.io if you have any questions and see our Terms Of Service for further information."
        }
    ];

    return (
        <BetaModalOverlay>
            <ModalContainer>
                {page <= 4 && (
                    <>
                        <InfoRow imgStart={true}>
                            <ImgWrap>
                                <Img src={pageContent[page - 1].img} alt={"Beta Information"} />
                            </ImgWrap>
                            <TextWrapper>
                                <TopLine>{pageContent[page - 1].topLine}</TopLine>
                                <Heading lightText={false}>{pageContent[page - 1].heading}</Heading>
                                <Subtitle darkText={true}>{pageContent[page - 1].subtitle}</Subtitle>
                            </TextWrapper>
                        </InfoRow>

                        <BtnWrap>
                            <FormButton disabled={page < 2} onClick={(e) => handleBack(e)}>Back</FormButton>
                            <ModalCloseButton onClick={(e) => handleClick(e)}>
                                {page === 4 ? "Close" : "Next"}
                            </ModalCloseButton>
                        </BtnWrap>
                    </>
                )}
            </ModalContainer>
        </BetaModalOverlay>

    );
};

export default BetaModal;